import $ from 'jquery';

/**
 * Loads an external Javascript file and executes it.
 *
 * @param url - The URL to the Javascript file
 * @param check - An optional function to return a boolean for manually checking if the script has correctly executed.
 *   This ensures that the callback actually happens after the script has been executed. For example, if loading jQuery
 *   this function could check whether the jQuery property exists on the window object.
 * @return Promise
 */
let loadedDependencies = null;
export function dependency(url, check=()=>true, timeout=10000) {

    if (!loadedDependencies) {
        loadedDependencies = {};

        // Add existing Javascript files as dependencies
        // TODO Handle `defer` and `async`
        $('script[src]').each(function() {
            const src = $(this).prop('src');
            loadedDependencies[src] = true;
        });
    }

    return new Promise(function(resolve, reject) {

        let startTime = Date.now();
        function poll() {
            if (check()) {
                resolve();
            } else if (Date.now() - startTime > timeout) {
                reject();
            } else {
                setTimeout(poll, 50);
            }
        }

        if(!loadedDependencies[url]) {
            loadedDependencies[url] = true;
            $.getScript(url).done(poll).fail(reject);
        } else {
            poll();
        }
    });
}



// WEBPACK FOOTER //
// ./source/scripts/utils/request.js